import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../api/clients';
import { toast } from 'sonner';

export interface Rol {
  id: number;
  nombre: string;
  descripcion: string | null;
  permisos: string | null;
  activo: boolean;
  createdAt: string;
  updatedAt: string;
}

export function useRoles() {
  return useQuery({
    queryKey: ['roles'],
    queryFn: async () => {
      const response = await api.get('/roles');
      return response.data?.data || [];
    },
    staleTime: 1000 * 60 * 2,
  });
}

export function useCreateRol() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: Partial<Rol>) => api.post('/roles', data).then(res => res.data.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['roles'] });
      toast.success('Rol creado exitosamente');
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al crear el rol');
    },
  });
}

export function useUpdateRol() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: Partial<Rol> }) =>
      api.put(`/roles/${id}`, data).then(res => res.data.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['roles'] });
      toast.success('Rol actualizado exitosamente');
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al actualizar el rol');
    },
  });
}

export function useDeleteRol() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.delete(`/roles/${id}`).then(res => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['roles'] });
      toast.success('Rol eliminado exitosamente');
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al eliminar el rol');
    },
  });
}